class Accordion {
    constructor(el) {
        this.blockElement = el;
        this.content = el.querySelector('.accordion-body');
        this.contentWrapper = el.querySelector('.accordion-body-inner-wrapper');
        this.toggleButton = el.querySelector('.js-accordion-toggle');
        this.contentHeight = 0;
        this.init();
    }
    init() {
        this.hideContent();
        this.calcHeight();
        this.addListeners();
    }
    calcHeight() {
        this.contentHeight = this.contentWrapper.offsetHeight;
    }
    toggleContent() {
        if (this.blockElement.classList.contains('active')) {
            this.hideContent();
        } else {
            this.showContent();
        }
    }
    hideContent() {
        this.blockElement.classList.remove('active');
        this.content.style.height = 0;
    }
    showContent() {
        this.blockElement.classList.add('active');
        this.content.style.height = this.contentHeight + 'px';
    }
    addListeners() {
        this.toggleButton.addEventListener('click', this.toggleContent.bind(this));
        window.addEventListener('resize', this.calcHeight.bind(this));
    }
}

const accordions = document.querySelectorAll('.js-accordion');
if (accordions) {
    accordions.forEach((el) => {
       new Accordion(el);
    });
}